module.exports = __webpack_public_path__ + "img/divider-icon.e2041e3f.svg";